import { observer } from 'mobx-react'
import { omit } from 'lodash'
import React from 'react'

export default function withObserver (Ctor) {
  return observer((props) => {
    const { getProps2Observe } = props
    const reactiveProps = getProps2Observe?.() || {}
    return <Ctor {...omit(props, ['getProps2Observe'])} {...reactiveProps} ></Ctor>
  })
}